import(/* webpackMode: "eager" */ "/app/src/app/[locale]/auth/magic-login/page.tsx");
